module.exports = __webpack_public_path__ + "img/item_zz.17acf27f.png";